import Vue from 'vue';
import { commits } from '@/modules/core/app/helpers/store';

export const mutations = {
  setVueBasedChartRender(state, { ready = true }) {
    window.vueBasedChartRender = ready;
  },
  setConfig(state, { config }) {
    state.config = config;
  },
  setIsExporting(state, { isExporting = true }) {
    state.isExporting = isExporting;
  },
  setExportReady(state, { ready = true }) {
    window.exportReady = ready;
    window.vueBasedChartRender = false;
    state.exportReady = ready;
  },
  setGhostWidget(state, { widgetId, message }) {
    state.ghostWidgets[widgetId] = message;
  },
  addToAppendedWidgets(state, { container, layoutId }) {
    const exists =
      state.paginatedWidgets?.[layoutId] &&
      state.paginatedWidgets[layoutId].find(
        (searchWidget) => searchWidget.widget.id === container.widget.id
      );
    if (!exists) {
      Vue.set(state.paginatedWidgets, layoutId, [
        ...(state.paginatedWidgets[layoutId] || []),
        container,
      ]);

      commits.dashboardExport.setPaginationRequiredWidgets({ widgetIds: [container.widget.id] });
    }
  },
};
